// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.action-buttons__confirmation-paragraph:first-child {\n  margin-bottom: 15px;\n}\n.action-buttons__confirmation-paragraph:last-child {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
